"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var ALIVECHECK_FIELDS = [{
  key: 'cpf',
  label: 'CPF',
  type: 'document'
}, {
  key: 'status',
  label: 'Status'
}, {
  key: 'nomeCompleto',
  label: 'Nome completo'
}, {
  key: 'dataNascimento',
  label: 'Data de nascimento',
  type: 'date'
}, {
  key: 'mesNascimento',
  label: 'Mês de nascimento'
}, {
  key: 'filiacao1',
  label: 'Filiação 1'
}, {
  key: 'filiacao2',
  label: 'Filiação 2'
}, {
  key: 'dataObito',
  label: 'Data do óbito',
  type: 'date'
}, {
  key: 'dataRegistro',
  label: 'Data do registro',
  type: 'date'
}, {
  key: 'fonteDado',
  label: 'Fonte dos dados'
}, {
  key: 'numeroCNJ',
  label: 'Número CNJ'
}, {
  key: 'registro',
  label: 'Registro'
}, {
  key: 'descricao',
  label: 'Descrição'
}];
var _default = exports.default = {
  name: 'PersonalConsultationDetail',
  bodyClass: 'personal-consultation-detail-page',
  components: {},
  data: function data() {
    return {
      activeTab: 0,
      operationId: null,
      personDetail: {},
      personDetailPh: {},
      personDetailNV: {},
      personDetailArPn: {},
      errorN: false,
      errorP: false,
      erroArPn: false,
      excludeds: ['ContactId', 'ID', 'SequencialId', 'FlagList', 'Flags', 'MarketingScore', 'Ranking'],
      listItemScore: [{
        title: 'Score de Crédito',
        value: '1.000',
        key: 'CADASTRAIS.SCORE'
      }, {
        title: 'Score de Risco',
        value: '',
        key: 'CADASTRAIS.MENSAGEMSCORE'
      }, {
        title: 'Processos Judiciais',
        value: '',
        key: 'QtdLegalProceedings'
      }, {
        title: 'Renda Presumida',
        value: '',
        key: 'IncomePresumed'
      }, {
        title: 'Classe Social',
        value: '',
        key: 'CADASTRAIS.CLASSEECONOMICA'
      }],
      listItemInformations: [{
        title: 'Geração',
        value: '1.000',
        key: 'CADASTRAIS.GERACAO'
      }, {
        title: 'Profissão',
        value: '',
        key: 'CADASTRAIS.POSSIVELPROFISSAO'
      }, {
        title: 'PPE',
        value: '',
        key: 'PEP.FLPEP'
      }, {
        title: 'Óbito',
        value: '',
        key: 'OBITO.FLOBITO'
      }, {
        title: 'Exposição mídia',
        value: '',
        key: 'Media'
      }],
      rowOneList: [{
        title: 'Alimentos e afins',
        icon: 'star-outline',
        key: 'ALIMENTOS E AFINS'
      }, {
        title: 'Automóveis e acessórios',
        icon: 'car-outline',
        key: 'AUTOMOVEIS E ACESSORIOS'
      }, {
        title: 'Beleza e estética',
        icon: 'star-outline',
        key: 'BELEZA E ESTETICA'
      }, {
        title: 'Brinquedos(crianças)',
        icon: 'star-outline',
        key: 'BRINQUEDOS, CRIANCAS E BEBES'
      }],
      rowTwoList: [{
        title: 'Casa e jardim',
        icon: 'sun-outline',
        key: 'CASA, JARDIM E FERRAMENTAS'
      }, {
        title: 'Ecommerce',
        icon: 'shopping-cart-outline',
        key: 'E_COMMERCE / VAREJISTA ONLINE'
      }, {
        title: 'Eletrônicos e jogos',
        icon: 'globe-outline',
        key: 'ELETRONICOSCOMPUTADORESEJOGOSEL'
      }, {
        title: 'Entretenimento/turismo',
        icon: 'briefcase-outline',
        key: 'ENTRETENIMENTO / TURISMO'
      }],
      rowThreeList: [{
        title: 'Gosto pelo luxo',
        icon: 'gift-outline',
        key: 'GOSTO PELO LUXO'
      }, {
        title: 'Produtos de pagamentos',
        icon: 'credit-card-outline',
        key: 'CARTAO DE CREDITO E PRODUTOS DE PAGAMENTOS'
      }, {
        title: 'Imóveis',
        icon: 'home-outline',
        key: 'IMOVEIS'
      }, {
        title: 'Internet',
        icon: 'wifi-outline',
        key: 'INTERNET'
      }],
      rowFourList: [{
        title: 'Motos e acessórios',
        icon: 'settings-2-outline',
        key: 'MOTOS E ACESSÓRIOS'
      }, {
        title: 'Pets',
        icon: 'github-outline',
        key: 'PETS'
      }, {
        title: 'Roupas sapatos e acessórios',
        icon: 'people-outline',
        key: 'ROUPAS, SAPATOS E ACESSORIOS'
      }, {
        title: 'Saúde e bem-estar',
        icon: 'sun-outline',
        key: 'SAUDE E BEM ESTAR'
      }],
      rowFiveList: [{
        title: 'Seguros',
        icon: 'shield-outline',
        key: 'SEGUROS'
      }, {
        title: 'Financiamento/Investimento',
        icon: 'bulb-outline',
        key: 'FINANCIAMENTOS E INVESTIMENTOS'
      }, {
        title: 'Livros e revistas',
        icon: 'book-open-outline',
        key: 'LIVROS, ASSINATURAS E REVISTAS'
      }]
    };
  },
  computed: {
    alivecheckFields: function alivecheckFields() {
      var _this = this;
      if (!this.personDetailArPn || _typeof(this.personDetailArPn) !== 'object' || Array.isArray(this.personDetailArPn)) {
        return [];
      }
      return ALIVECHECK_FIELDS.reduce(function (fields, field) {
        var value = _this.personDetailArPn[field.key];
        if (!_this.isAlivecheckValueAvailable(value)) {
          return fields;
        }
        var formattedValue = value;
        if (field.key === 'status') {
          formattedValue = _this.formatAlivecheckCardStatus(value);
        } else if (field.type === 'date') {
          formattedValue = _this.formatAlivecheckDate(value);
        } else if (field.type === 'document') {
          formattedValue = _this.formatAlivecheckDocument(value);
        }
        fields.push({
          key: field.key,
          label: field.label,
          value: formattedValue
        });
        return fields;
      }, []);
    },
    alivecheckFieldRows: function alivecheckFieldRows() {
      return this.alivecheckFields.filter(function (field) {
        return field.key !== 'descricao';
      }).reduce(function (rows, field, index) {
        if (index % 3 === 0) {
          rows.push([]);
        }
        rows[rows.length - 1].push(field);
        return rows;
      }, []);
    },
    alivecheckDescription: function alivecheckDescription() {
      return this.alivecheckFields.find(function (field) {
        return field.key === 'descricao';
      }) || null;
    },
    deathIndication: function deathIndication() {
      var _this$personDetailArP;
      return this.formatDeathIndication((_this$personDetailArP = this.personDetailArPn) === null || _this$personDetailArP === void 0 ? void 0 : _this$personDetailArP.status);
    },
    hasAlivecheckData: function hasAlivecheckData() {
      return this.alivecheckFields.length > 0;
    },
    hasContactInfos: function hasContactInfos() {
      return this.hasValues(this.personDetailNV) || this.hasValues(this.personDetailPh);
    },
    hasAddressNV: function hasAddressNV() {
      return this.hasValues(this.personDetailNV);
    },
    hasAddressPH: function hasAddressPH() {
      return this.hasValues(this.personDetailPh);
    },
    hasProfissionalData: function hasProfissionalData() {
      return this.hasValues(this.personDetailNV) || this.hasValues(this.personDetailPh);
    },
    hasCreditData: function hasCreditData() {
      return this.hasValues(this.personDetailNV) || this.hasValues(this.personDetailPh);
    },
    hasProfileConsumeData: function hasProfileConsumeData() {
      return this.hasValues(this.personDetailNV) || this.hasValues(this.personDetailPh);
    },
    userImg: function userImg() {
      var _this$personDetail;
      return "data:image/png;base64,".concat((_this$personDetail = this.personDetail) === null || _this$personDetail === void 0 ? void 0 : _this$personDetail.imageBase64);
    },
    dataConsults: function dataConsults() {
      var _this2 = this;
      var arrayData = [];
      var array = _objectSpread(_objectSpread(_objectSpread({}, this.personDetailNV), this.personDetailPh), this.personDetailArPn);
      if (array && array.Name) {
        Object.entries(array).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          if (!_this2.excludeds.includes(key)) {
            var item = {
              key: key,
              value: value,
              type: _typeof(value)
            };
            if (Array.isArray(value)) {
              item.type = 'array';
            }
            arrayData.push(item);
          }
        });
      }
      return arrayData;
    },
    sociedades: function sociedades() {
      var _this$personDetailNV;
      var data = (_this$personDetailNV = this.personDetailNV) === null || _this$personDetailNV === void 0 ? void 0 : _this$personDetailNV.SOCIEDADES;
      if (data && data.length) {
        var _this$personDetailNV2, _this$personDetailNV3;
        if (!data[0].CNPJ) return [];
        return (_this$personDetailNV2 = this.personDetailNV) === null || _this$personDetailNV2 === void 0 ? void 0 : (_this$personDetailNV3 = _this$personDetailNV2.SOCIEDADES) === null || _this$personDetailNV3 === void 0 ? void 0 : _this$personDetailNV3.slice(0, 3);
      }
      return [];
    },
    professionalData: function professionalData() {
      var _this$personDetailPh;
      var data = (_this$personDetailPh = this.personDetailPh) === null || _this$personDetailPh === void 0 ? void 0 : _this$personDetailPh.ProfessionalData;
      if (data && data.length) {
        var _this$personDetailPh2, _this$personDetailPh3;
        return (_this$personDetailPh2 = this.personDetailPh) === null || _this$personDetailPh2 === void 0 ? void 0 : (_this$personDetailPh3 = _this$personDetailPh2.ProfessionalData) === null || _this$personDetailPh3 === void 0 ? void 0 : _this$personDetailPh3.slice(0, 3);
      }
      return [];
    },
    emailsNV: function emailsNV() {
      var _this$personDetailNV4;
      var data = (_this$personDetailNV4 = this.personDetailNV) === null || _this$personDetailNV4 === void 0 ? void 0 : _this$personDetailNV4.EMAILS;
      if (data && data.length) {
        var _this$personDetailNV5, _this$personDetailNV6;
        if (!data[0].EMAIL) return [];
        return (_this$personDetailNV5 = this.personDetailNV) === null || _this$personDetailNV5 === void 0 ? void 0 : (_this$personDetailNV6 = _this$personDetailNV5.EMAILS) === null || _this$personDetailNV6 === void 0 ? void 0 : _this$personDetailNV6.slice(0, 3);
      }
      return [];
    }
  },
  // userImg
  created: function created() {
    var id = this.$route.params.id;
    this.operationId = id;
    this.getData();
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchPersonalConsultation'])), {}, {
    isAlivecheckValueAvailable: function isAlivecheckValueAvailable(value) {
      return value !== null && value !== undefined && (typeof value !== 'string' || value.trim() !== '');
    },
    normalizeAlivecheckStatus: function normalizeAlivecheckStatus(value) {
      if (value === null || value === undefined) {
        return '';
      }
      return String(value).trim().toLowerCase();
    },
    formatDeathIndication: function formatDeathIndication(value) {
      var deathIndications = {
        obito: 'SIM',
        vivo: 'NÃO',
        indefinido: 'Análise Inconclusiva'
      };
      return deathIndications[this.normalizeAlivecheckStatus(value)] || '';
    },
    formatAlivecheckCardStatus: function formatAlivecheckCardStatus(value) {
      var statusDescriptions = {
        obito: 'Óbito',
        indefinido: 'Análise Inconclusiva'
      };
      var normalizedStatus = this.normalizeAlivecheckStatus(value);
      return statusDescriptions[normalizedStatus] || String(value);
    },
    formatAlivecheckDocument: function formatAlivecheckDocument(value) {
      var document = String(value);
      return /^\d{11}$/.test(document) ? this.$options.filters.maskCPF(document) : document;
    },
    formatAlivecheckDate: function formatAlivecheckDate(value) {
      if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return value;
      }
      var _value$split$map = value.split('-').map(Number),
        _value$split$map2 = _slicedToArray(_value$split$map, 3),
        year = _value$split$map2[0],
        month = _value$split$map2[1],
        day = _value$split$map2[2];
      var date = new Date(Date.UTC(year, month - 1, day));
      var isValidDate = date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
      return isValidDate ? this.$options.filters.dateFormat(value) : value;
    },
    hasValues: function hasValues(obj) {
      return obj && _typeof(obj) === 'object' && Object.values(obj).some(function (val) {
        return val !== null && val !== undefined && val !== '';
      });
    },
    getData: function () {
      var _getData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$this$fetchPers, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.fetchPersonalConsultation(this.operationId);
            case 1:
              _yield$this$fetchPers = _context.v;
              data = _yield$this$fetchPers.data;
              if (data) {
                this.errorN = this.hasValues(data.enriquecimentoComplete) && data.checkboxEnrichment ? !(data !== null && data !== void 0 && data.dataEnriquecimentoCompleteSuccess) : false;
                this.errorP = this.hasValues(data.enriquecimento) && data.checkboxEnrichment ? !(data !== null && data !== void 0 && data.dataEnriquecimentoSuccess) : false;
                this.erroArPn = this.hasValues(data.alivecheckComplete) && data.checkboxAlivecheck ? !(data !== null && data !== void 0 && data.dataAlivecheckCompleteSuccess) : false;
                this.personDetail = data;
                this.personDetailPh = data.enriquecimento;
                this.personDetailNV = data.enriquecimentoComplete;
                this.personDetailArPn = data.alivecheckComplete;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }(),
    goBack: function goBack() {
      this.$router.back();
    },
    getValue: function getValue(key) {
      var returnKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // buscar o scrore de credito da novavida
      if (key === 'IncomePresumed') {
        var _this$personDetailPh4, _this$personDetailPh5;
        return (_this$personDetailPh4 = this.personDetailPh) === null || _this$personDetailPh4 === void 0 ? void 0 : (_this$personDetailPh5 = _this$personDetailPh4.Income) === null || _this$personDetailPh5 === void 0 ? void 0 : _this$personDetailPh5.Presumed;
      }
      if (!this.personDetail) return 'N';
      if (!key) return 'N';
      var value = this.personDetailNV[key];
      if (key.indexOf('.') > -1) {
        var keys = key.split('.');
        if (keys.length === 2) {
          if (this.personDetailNV[keys[0]]) {
            var keyOne = keys[0];
            var keyTwo = keys[1];
            value = this.personDetailNV[keyOne][keyTwo];
          }
        }
      }
      if (value) return value;
      return 'N';
    },
    getValueInterest: function getValueInterest(key) {
      var _this$personDetailNV7;
      var returnKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var consumos = [];
      if ((_this$personDetailNV7 = this.personDetailNV) !== null && _this$personDetailNV7 !== void 0 && _this$personDetailNV7.PERFILCONSUMO) {
        var _this$personDetailNV8, _this$personDetailNV9;
        consumos = (_this$personDetailNV8 = this.personDetailNV) === null || _this$personDetailNV8 === void 0 ? void 0 : (_this$personDetailNV9 = _this$personDetailNV8.PERFILCONSUMO) === null || _this$personDetailNV9 === void 0 ? void 0 : _this$personDetailNV9.CONSUMO.split('|');
      }
      if (!consumos || !consumos.length) return 0;
      var verify = consumos.includes(key);
      if (verify) return 1;
      return 0;
    },
    formatAddress: function formatAddress(item) {
      return "".concat(item.LOGRADOURO, ", ").concat(item.BAIRRO, ", ").concat(item.CIDADE, " ").concat(item.UF, " (CEP: ").concat(item.CEP, ")").concat(item.AREARISCO === 'S' ? ' - (AREA DE RISCO)' : '');
    },
    formatPhone: function formatPhone(item) {
      var phone = this.$options.filters.maskPhoneMinus(item.TELEFONE);
      return "(".concat(item.DDD, ") ").concat(phone);
    },
    verifyEmailExistNV: function verifyEmailExistNV(mail) {
      var _this$personDetailNV0, _this$personDetailNV1;
      var verify = (_this$personDetailNV0 = this.personDetailNV) === null || _this$personDetailNV0 === void 0 ? void 0 : (_this$personDetailNV1 = _this$personDetailNV0.EMAILS) === null || _this$personDetailNV1 === void 0 ? void 0 : _this$personDetailNV1.find(function (i) {
        return i.EMAIL === mail;
      });
      return !!verify;
    },
    verifyEmailExistPH: function verifyEmailExistPH(mail) {
      var _this$personDetailPh6, _this$personDetailPh7;
      var verify = (_this$personDetailPh6 = this.personDetailPh) === null || _this$personDetailPh6 === void 0 ? void 0 : (_this$personDetailPh7 = _this$personDetailPh6.Emails) === null || _this$personDetailPh7 === void 0 ? void 0 : _this$personDetailPh7.find(function (i) {
        return i.Email === mail;
      });
      return !!verify;
    },
    verifyPhoneExistPH: function verifyPhoneExistPH(phone) {
      var _this$personDetailPh8, _this$personDetailPh9;
      var verify = (_this$personDetailPh8 = this.personDetailPh) === null || _this$personDetailPh8 === void 0 ? void 0 : (_this$personDetailPh9 = _this$personDetailPh8.Phones) === null || _this$personDetailPh9 === void 0 ? void 0 : _this$personDetailPh9.find(function (i) {
        return i.FormattedNumber === phone;
      });
      return !!verify;
    },
    verifyPhoneExistNV: function verifyPhoneExistNV(phone) {
      var _this$personDetailNV10,
        _this$personDetailNV11,
        _this3 = this;
      var verify = (_this$personDetailNV10 = this.personDetailNV) === null || _this$personDetailNV10 === void 0 ? void 0 : (_this$personDetailNV11 = _this$personDetailNV10.TELEFONES) === null || _this$personDetailNV11 === void 0 ? void 0 : _this$personDetailNV11.find(function (i) {
        return _this3.formatPhone(i) === phone;
      });
      return !!verify;
    },
    descriptionPersonCredit: function descriptionPersonCredit(type) {
      return this.$options.filters.translatePersonCredito(type);
    }
  })
};